//@flow
import Collection from '../../Utils/Collection/parsedCollection';
import AddressModel from './addressModel';
import _ from 'underscore';

import type { AddressObject } from './addressModel';

export default class AddressesCollection extends Collection<AddressObject, AddressModel> {
  __modelClass() {
    return AddressModel;
  }

  addAddress(addressData:AddressObject) {
    const address = new AddressModel(addressData);
    this.models.push(address);
  }

  findById(id:?string|number):?AddressModel {
    return _.find(this.models, address => parseInt(address.getId()) === parseInt(id));
  }

  getDefaultShippingAddress():?AddressModel {
    return _.find(this.models, address => !!address.getIsDefaultShipping());
  }
}
